// @flow
import * as React from 'react';
import ContainerWrapper from './Container.style';
import type { ContainerProps } from './Container.types';

function Container(props: ContainerProps) {
  const { className, children } = props;

  return <ContainerWrapper className={className}>{children}</ContainerWrapper>;
}

export default Container;
